import { ProductSlider, mapProductFromSuggested } from './ProductSlider.refactored'

export default ProductSlider
export {
    mapProductFromSuggested
}
